import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import GoHubApp from "./GoHubApp";

// Ignore harmless ResizeObserver browser warnings.
// In development, React's error overlay can otherwise
// display these as runtime errors.
window.addEventListener("error", (event) => {
  const message = String(event?.message || "");

  if (
    message.includes(
      "ResizeObserver loop completed with undelivered notifications"
    ) ||
    message.includes(
      "ResizeObserver loop limit exceeded"
    )
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);
const resizeObserverErrors = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications.",
];

window.addEventListener("error", (event) => {
  if (
    resizeObserverErrors.some((message) =>
      String(event.message || "").includes(message)
    )
  ) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(<GoHubApp />);

// Evict any service worker left over from older builds they
// cache stale bundles and survive deploys until unregistered.
// No current code registers one (verified), so this only hunts
// fossils in visitors' browsers, then does nothing forever after.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });

  if (window.caches) {
    caches.keys().then((keys) => keys.forEach((key) => caches.delete(key)));
  }
}